module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Aigle-fb84573d0501990f4f342fcc92fffe42.svg";